import React from 'react';

import symbolLogo from 'assets/images/symbol.svg';

function Header({ setIsPopupOpen, isStarted }) {
  return (
    <div id="header" style={{ backgroundColor: isStarted ? 'transparent' : '#ffffff' }}>
      <h1 className="logo">
        <a href="/">
          <img src={symbolLogo} alt="공유디자이너랩 로고" />
        </a>
      </h1>
      <a className="btn-reservation" onClick={() => setIsPopupOpen(true)}>
        시설예약하기
      </a>
    </div>
  );
}

export default Header;
